let reqApiUrl = ''
let downloadUrl = ''
let openAccountPortfolioUrl=''//投资组合开户
// switch (import.meta.env.PUBLIC_ENV) {
//   case 'dev':
//     downloadUrl = 'http://dev.winbull.cc/h5/s/download.html'
//     openAccountPortfolioUrl = 'https://uat.winbull.cc/h5/openAccount/index_multiple.html#/ol_multiple/portfolio_renewal'
//   case 'sit':
//     downloadUrl = 'https://sit.winbull.cc:10443/h5/s/download.html'
//     openAccountPortfolioUrl = 'https://uat.winbull.cc/h5/openAccount/index_multiple.html#/ol_multiple/portfolio_renewal'
//   case 'uat':
//     downloadUrl = 'https://uat.winbull.cc/h5/s/download.html'
//     openAccountPortfolioUrl = 'https://uat.winbull.cc/h5/openAccount/index_multiple.html#/ol_multiple/portfolio_renewal'
//   case 'prod':
//     reqApiUrl = window.location.protocol + '//' + window.location.host
//     downloadUrl = 'https://www.winbulls.com/s/download.html'
//     openAccountPortfolioUrl = 'https://www.winbulls.com/h5/openAccount/index_multiple.html#/ol_multiple/portfolio_renewal'
//     break
//   default:
//     reqApiUrl = '/devApi'
//     downloadUrl = 'http://dev.winbull.cc/h5/s/download.html'
//     openAccountPortfolioUrl = 'https://uat.winbull.cc/h5/openAccount/index_multiple.html#/ol_multiple/portfolio_renewal'
//     break
// }

if(import.meta.env.PUBLIC_ENV=="dev"){
   downloadUrl = 'http://dev.winbull.cc/h5/s/download.html'
   openAccountPortfolioUrl = 'https://uat.winbull.cc/h5/openAccount/index_multiple.html#/ol_multiple/portfolio_renewal'
}else if(import.meta.env.PUBLIC_ENV=="sit"){
   downloadUrl = 'https://sit.winbull.cc:10443/h5/s/download.html'
   openAccountPortfolioUrl = 'https://uat.winbull.cc/h5/openAccount/index_multiple.html#/ol_multiple/portfolio_renewal'
}else if(import.meta.env.PUBLIC_ENV=="uat"){
   downloadUrl = 'https://uat.winbull.cc/h5/s/download.html'
   openAccountPortfolioUrl = 'https://uat.winbull.cc/h5/openAccount/index_multiple.html#/ol_multiple/portfolio_renewal'
}else if(import.meta.env.PUBLIC_ENV=="prod"){
   reqApiUrl = window.location.protocol + '//' + window.location.host
   downloadUrl = 'https://www.winbulls.com/s/download.html'
   openAccountPortfolioUrl = 'https://www.winbulls.com/h5/openAccount/index_multiple.html#/ol_multiple/portfolio_renewal'
}else{
   reqApiUrl = '/devApi'
   downloadUrl = 'http://dev.winbull.cc/h5/s/download.html'
   openAccountPortfolioUrl = 'https://uat.winbull.cc/h5/openAccount/index_multiple.html#/ol_multiple/portfolio_renewal'
}

export { reqApiUrl,downloadUrl,openAccountPortfolioUrl } //可以导出更多需要不同环境区分的url
